import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";

const ProtectedRoute = ({ children }) => {
  const { authState } = useOktaAuth();
  const location = useLocation();

  if (!authState) {
    return <p>Loading...</p>;
  }

  return authState.isAuthenticated ? (
    children
  ) : (
    <Navigate to="/signin" state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
